import { Injectable, Optional } from '@angular/core';
import { Entity, BindingData, FrameContext, ViewModel } from '@farris/devkit';
import { BefRepository, BefRepositoryUtil } from '@farris/bef';
import { Observable, of, empty, EMPTY, concat, zip, from, Subject } from 'rxjs';
import { tap, switchMap, concatMap, concatAll, takeLast, last } from 'rxjs/operators';
import { FormLoadingService } from '../form-loading/form-loading.service';
import { LanguageService } from '../languag.service';
import { FormNotifyService } from '../form-notify.service';
import { FormMessageService } from '../form-message.service';
import { FormErrorService } from '../error/form-error.service';
import { EditStateUtil } from './utils/index';
import { FormNotifyStrategyService } from '../form-notify-strategy.service';
import { RuntimeFrameworkService } from '../rtf-service';
import { DataType, WEB_FORM_ROUTE_PARAMS_KEY } from '../types';
import { CommandService } from '../command-service';
import { ValidationService } from '../validation.service';
import { DataChangeDetectionService } from '../data-change-detection.service';
// tslint:disable: no-string-literal
// tslint:disable: max-line-length
/**
 * å¡çä»åºæå¡
 */
@Injectable()
class CardDataService {

  /**
   * å®ä½ä»åº
   */
  private repository: BefRepository<Entity>;

  /**
   * ç»å®æ°æ®
   */
  private bindingData: BindingData;

  /**
   * æé å½æ°
   */
  constructor(
    private formMessageService: FormMessageService,
    private frameContext: FrameContext,
    private loadingService: FormLoadingService,
    private formNotifyService: FormNotifyService,
    @Optional() private languageService: LanguageService,
    private formErrorService: FormErrorService,
    private runtimeFrameworkService: RuntimeFrameworkService,
    private commandService: CommandService
  ) {
    if (!languageService) {
      this.languageService = LanguageService.getInstance();
    }
    this.repository = this.frameContext.repository as BefRepository<Entity>;
    this.bindingData = this.frameContext.bindingData;
  }

  /**
   * å è½½æ°æ®
   * @param id ä¸»å®ä½id
   * @param enableChildrenPagination å¯ç¨å­è¡¨åé¡µ
   */
  public load(id: string): Observable<Entity> {
    const loadingTimerId = this.loadingService.showLoadingWithDelay(500);
    this.frameContext.appContext.params.set("retrieveing", true);
    this.frameContext.appContext.params.delete('queryChild');
    const get$ = this.repository.getById(id);
    return get$.pipe(
      tap(
        () => {
          this.loadingService.hideDelayLoading(loadingTimerId);
        },
        (error: any) => {
          this.loadingService.hideDelayLoading(loadingTimerId);
          this.formErrorService.exception(this.languageService.loadFailed, error);
        }
      )
    );
  }
  /**
   * å è½½å
   * @param id id
   * @param transitionActionParamName ç¶æè¿ç§»å¨ä½åæ°ç¼å·
   * @returns
   */
  public onLoading(transitionActionParamName: string) {
    const tabId = this.runtimeFrameworkService && this.runtimeFrameworkService.tabId || null;
    if (!tabId) {
      return;
    }
    let skip = true;
    const listening = this.frameContext.appContext.params.get(tabId) || false;
    transitionActionParamName = transitionActionParamName || 'transitionAction';
    if (!listening) {
      this.frameContext.appContext.params.set(tabId, true);
      this.runtimeFrameworkService.getEntityParam(tabId, (options: any) => {
        if (skip) {
          skip = false;
          return;
        }
        const params = this.parseParams(options);
        if (params && params.sync) {
          const action = params.action;
          const id = params.id;
          const ngCommand = this.frameContext && this.frameContext.viewModel && this.frameContext.viewModel.metadatas && this.frameContext.viewModel.metadatas[action];
          const actionName = ngCommand.params && ngCommand.params[transitionActionParamName] || null;
          const formPrimaryValue = this.frameContext.bindingData.list.currentId;
          const formState = this.frameContext.stateMachine.context.state;
          let state = null;
          let stateName: string;
          if (!actionName) {
            // å¯è½æ¯ç¨æ·èªå·±éç½®çå½ä»¤ï¼æ²¡æç¶ææºåæ¢ï¼æ­¤æ¶ä¸åå¤æ­ç¶ææº
            state = formState;
          }
          else {
            const ngAction = this.frameContext && this.frameContext.stateMachine && this.frameContext.stateMachine.metadatas && this.frameContext.stateMachine.metadatas.actions && this.frameContext.stateMachine.metadatas.actions[actionName];
            state = ngAction && ngAction.transitTo || formState;
            stateName = this.frameContext && this.frameContext.stateMachine && this.frameContext.stateMachine.metadatas && this.frameContext.stateMachine.metadatas && this.frameContext.stateMachine.metadatas.states[state] && this.frameContext.stateMachine.metadatas.states[state].name || this.languageService.defaultStateName;
            if (stateName && stateName.startsWith('{{') && stateName.endsWith('}}')) {
              const key = stateName.replace('{{', '').replace('}}', '');
              stateName = this.frameContext.translate.transform(key, null);
            }
          }
          const primaryValueChanged = formPrimaryValue !== id;
          const stateChanged = formState !== state;

          if (primaryValueChanged && stateChanged) {
            // ååçåå
            const message = this.languageService.dataAndStateChanged.replace(/\$1/g, stateName);
            this.showLoadingConfirm(message).pipe(switchMap(() => {
              return this.resetForm(action);
            })).subscribe();
          } else if (primaryValueChanged) {
            // ä¸»é®åçåå
            this.showLoadingConfirm(this.languageService.dataChanged).pipe(switchMap(() => {
              return this.resetForm(action);
            })).subscribe();
          } else if (stateChanged) {
            // ç¶æåçåå
            const message = this.languageService.stateChanged.replace(/\$1/g, stateName);
            this.showLoadingConfirm(message).pipe(switchMap(() => {
              return this.resetForm(action);
            })).subscribe();
          } else {
            // æ°æ®åç¶æåæªåçåå
            return of(true);
          }
        }
      }, false);
    }
  }

  /**
   * æ°å¢
   */
  public add(): Observable<any> {
    const lastModifiedId = this.bindingData.list.currentId;

    const loadingTimerId = this.loadingService.showLoadingWithDelay(500);
    const create$ = this.repository.create();
    return create$.pipe(
      tap(
        () => {
          EditStateUtil.setEditState(this.frameContext, lastModifiedId);
          this.loadingService.hideDelayLoading(loadingTimerId);
        },
        (error: any) => {
          this.loadingService.hideDelayLoading(loadingTimerId);
          this.formErrorService.exception(this.languageService.addFailed, error);
        }
      )
    );
  }
  /**
   * çº§èæ°å¢
   */
  public cascadeAdd(): Observable<any> {
    const subject = new Subject<any>();
    // æ¾å°ææviewmodel,æ¿å°äºææçframeContextï¼å¯è½æç»åè¡¨åç
    const frameContexts = this.frameContext.appContext.frameContextManager.getFrameContexts();
    // æ¾å°å½åframeContextçå¬å±namespace
    const currentNamespace = this.frameContext.getVirtualRootFrameContext().namespace;
    // æ¿å°å½åå½ä»¤æå¨frameçè¡¨åçææframeContext
    const currentFormFrameContexts = frameContexts.filter((context: FrameContext) => context.namespace === currentNamespace) || [];
    let bindingPaths = [];
    if (currentFormFrameContexts && currentFormFrameContexts.length > 0) {
      // æ¾å°ææä¸çº§frameContext
      const childFrameContexts = currentFormFrameContexts.filter((context: FrameContext) => context.viewModel.bindingPath && context.viewModel.bindingPath !== '/');
      if (childFrameContexts && childFrameContexts.length > 0) {
        let childBindingPaths = childFrameContexts.map((context: FrameContext) => context.viewModel.bindingPath);
        childBindingPaths = childBindingPaths.filter((item, index) => childBindingPaths.indexOf(item) === index);
        if (childBindingPaths && childBindingPaths.length > 0) {
          bindingPaths = childBindingPaths.map((path) => path.split('/').filter((p) => p)).sort((a, b) => a.length - b.length);
        }
      }
    }
    this.loadingService.show();
    this.repository.create().pipe(
      switchMap((entity: Entity) => {
        const rid = entity.primaryValue;
        if (bindingPaths && bindingPaths.length > 0) {
          return from(bindingPaths).pipe(
            concatMap((bindingPath: Array<any>) => {
              const fpath = this.getPath(this.frameContext.viewModel, '/' + bindingPath.join('/'), rid);
              return this.repository.appendByPath(fpath);
            })
          );
        } else {
          return of(entity);
        }
      })
    ).pipe(last()).subscribe(
      () => {
        this.loadingService.hide();
        subject.next();
      },
      (error: any) => {
        this.loadingService.hide();
        this.formErrorService.exception(this.languageService.addFailed, error);
      });
    return subject;
  }

  /**
   * ç¼è¾ï¼æ´æ°æ°æ®å¹¶æ è®°ç¼è¾ç¶æï¼
   */
  public edit(id?: string): Observable<Entity> {
    const update$ = this.update();
    return update$.pipe(
      tap(() => {
        const currentId = this.bindingData.list.currentId
        EditStateUtil.setEditState(this.frameContext, currentId);
      })
    );
  }

  /**
   * æ´æ°
   * @param id ä¸»å®ä½id
   * @param enableChildrenPagination å¯ç¨å­è¡¨åé¡µ
   */
  public update(id?: string): Observable<Entity> {
    // è·åid
    id = this.bindingData.list.currentId as string;
    if (!id) {
      return empty();
    }
    const loadingTimerId = this.loadingService.showLoadingWithDelay(500);
    const update$ = this.repository.updateById(id);
    this.frameContext.appContext.params.set("retrieveing", true);
    return update$.pipe(
      tap(() => {
        this.loadingService.hideDelayLoading(loadingTimerId);
      },
        (error) => {
          this.loadingService.hideDelayLoading(loadingTimerId);
          this.formErrorService.exception(this.languageService.updateFailed, error);
        }
      )
    );
  }
  public updateWithoutEmpty() {
    // è·åid
    const id = this.bindingData.list.currentId as string;
    if (!id) {
      return of(null);
    } else {
      return this.update();
    }
  }
  /**
   * æ ¡éªå½åè¡æ¯å¦å­å¨
   * @returns
   */
  public checkBeforeUpdate(): Observable<boolean> {
    const bindingList = this.frameContext.bindingData.list;
    const id = bindingList && bindingList.currentId;
    if (!id) {
      this.formNotifyService.warning(this.languageService.noDataExist, { hideTitle: true });
      return EMPTY;
    }
    return of(true);
  }
  /**
   * å·²åºå¼
   * @returns
   */
  public updateWithNotify() {
    // è·åid
    const id = this.bindingData.list.currentId as string;
    if (!id) {
      this.formNotifyService.warning(this.languageService.noDataExist, { hideTitle: true });
      return EMPTY;
    } else {
      return this.update();
    }
  }
  /**
   * å è½½å¡çæ°æ®ï¼åé¡µå è½½å­è¡¨æ°æ®ï¼
   * @deprecated æ¹æ³å·²åºå¼ï¼è¯·å¿ä½¿ç¨
   */
  public loadPaged(filter?: string, sort?: string) {
    // è·åid
    const id = this.bindingData.list.currentId as string;
    if (!id) {
      return EMPTY;
    }

    const loadingTimerId = this.loadingService.showLoadingWithDelay(500);
    // this.frameContext.root.params.set('updateWithPaging', true);
    const update$ = of(null);//this.repository.updateEntityById(id, true);
    return update$.pipe(
      tap(() => {
        this.loadingService.hideDelayLoading(loadingTimerId);
      },
        (error) => {
          this.loadingService.hideDelayLoading(loadingTimerId);
          this.formErrorService.exception(this.languageService.updateFailed, error);
        }
      )
    );
  }
  /**
   * ä¿å­
   */
  public save(successMsg?: string): Observable<boolean> {
    // è·åå½åè¡
    const id = this.bindingData.list.currentId as string;
    if (!id) {
      return of(false);
    }

    const loadingTimerId = this.loadingService.showLoadingWithDelay(500);
    const update$ = this.repository.updateChangesById(id);
    const save$ = this.repository.applyChangesById(id);
    const result$ = update$.pipe(

      // update$ => save$
      switchMap((updateResult: boolean) => {
        if (updateResult === false) {
          return of(false);
        } else {
          return save$;
        }
      }),

      // éèloading
      tap(() => {

        // åæ¶æ°å¢ç¶æ
        EditStateUtil.setEditState(this.frameContext, id);
        this.loadingService.hideDelayLoading(loadingTimerId);
        // this.formNotifyService.info(this.languageService.saveSuccess);
        if (successMsg && successMsg.trim()) {
          let showMessage: boolean = true;
          if (successMsg.startsWith('{') && successMsg.endsWith('}')) {
            try {
              const options = JSON.parse(successMsg);
              if (options.showMessage === false) {
                showMessage = false;
              }
            } catch { }
          }
          if (showMessage !== false) {
            this.formNotifyService.success(successMsg, { hideTitle: true });
          }
        } else {
          FormNotifyStrategyService.success(this.formNotifyService, this.languageService.saveSuccess);
        }
        // FormNotifyStrategyService.success(this.formNotifyService, this.languageService.saveSuccess);
      },
        (error) => {
          this.loadingService.hideDelayLoading(loadingTimerId);
          this.formErrorService.exception(this.languageService.saveFailed, error);
        }
      )
    );

    return result$;
  }


  // #region åæ¶ç¸å³æ¹æ³

  /**
   * åæ¶ï¼é»è®¤åæ¶ï¼
   */
  public cancel(): Observable<any> {
    return this.cancelWithCheck();
  }

  /**
   * è¿ååæ´é
   * @description ä¸å¸¦åæ´æ£æµæç¤º
   */
  public revert(options?: any): Observable<any> {
    return this.cancelWithoutCheck(options);
  }

  /**
   * åæ¶ï¼åæ¶åæ£æ¥æªä¿å­çåæ´ï¼
   * @summary
   * 1ãç¨æ·è¯¯æä½ï¼åªéè¦åä¸ªæç¤ºå°±å¯ä»¥äºï¼
   * 2ãç¨æ·ææåæ¶ï¼ç¹å»åæ¶å°±æ¯è¦æ¾å¼ææåæ´ï¼è¿æ¶åè¯¢é®äººå®¶æ¯å¦è¦ä¿å­æèæç¤ºå­å¨åæ´æç¹å¤æ­¤ä¸ä¸¾ï¼ç¡®è®¤ä¸æå³å¯ã
   * 3ãç¨æ·è¯¯æä½ï¼æ²¡æåæ´çæåµä¸ç´æ¥ç»åæ¶äºï¼ç¨æ·ä¼äº§çææï¼å ä¸ºç¨æ·ææ¶åå¹¶ä¸ç¡®å®æ¯å¦æåæ´ï¼åºè¯¥ä¹ç¡®è®¤ä¸æã
   * @todo
   * 1ãç±äºäº§åé¨å¾å¤ä»£ç è¯¯ç¨äºè¯¥æ¹æ³ï¼ä¾èµäºæ²¡æåæ´çæ¶åç´æ¥åæ¶ï¼ç°å¨å¼¹çªç¡®è®¤æ¡æ¥ï¼ä¸å¤ªåéï¼
   * 2ãäº§åé¨éè¦ç¨cancelWithoutCheckæ¹æ³ä»£æ¿ï¼ç®ååç»å¼å®¹çï¼å¾å é¤ã
   */
  public cancelWithCheck() {
    const hasChange$ = DataChangeDetectionService.hasChange(this.frameContext);
    return hasChange$.pipe(
      switchMap((changed: boolean) => {
        if (!changed) {
          return this.cancelChanges();
        } else {
          // ç¡®è®¤æ¯å¦åæ¶
          const confirm$ = this.formMessageService.question(this.languageService['cancelWithoutSave']);
          const result$ = confirm$.pipe(
            switchMap((ifCancel: boolean) => {
              if (ifCancel === false) {
                return EMPTY;
              }
              return this.cancelChanges();
            })
          );
          return result$;
        }
      })
    );
  }

  /**
   * åæ¶ï¼ç´æ¥åæ¶ï¼ä¸æ§è¡æ£æ¥ï¼
   */
  public cancelWithoutCheck(options?: any) {
    return this.cancelChanges(options);
  }

  /**
   * åæ¶
   */
  private cancelChanges(options?: any): Observable<any> {
    const loadingTimerId = this.loadingService.showLoadingWithDelay(500);
    const cancel$ = this.repository.cancelChanges(options);
    return cancel$.pipe(
      tap(
        () => {
          EditStateUtil.setEditState(this.frameContext, '');
          this.loadingService.hideDelayLoading(loadingTimerId);
        },
        (error) => {
          this.loadingService.hideDelayLoading(loadingTimerId);
          this.formErrorService.exception(this.languageService.cancelFailed, error);
        }
      )
    );
  }

  // #endregion


  /**
   * éæ°å è½½ï¼ä»ä¾å¡çåæ¶åéæ°å è½½æ°æ®ï¼å¶ä»åºæ¯è¯·å¿ä½¿ç¨ï¼
   */
  public reload() {
    const isAdd = EditStateUtil.getAddState(this.frameContext);
    let id;
    if (isAdd === true) {
      id = EditStateUtil.getLastModifiedId(this.frameContext);
    } else {
      id = this.bindingData.list.currentId as string;
    }

    if (!id) {
      this.repository.entityCollection.loadEntities([]);
      return;
    }

    return this.load(id);
  }
  private getPath(viewModel: ViewModel, bindingPath: string, rid: string): string {
    let path = '/' + rid;

    const subPaths = bindingPath.split('/');
    if (subPaths.length > 0) {
      // eg:bindingPathå½¢å¦/edus/grades,splitåæ¯['', 'edus', 'grades']
      // å æ­¤indexä»1å¼å§
      for (let index = 1; index < subPaths.length - 1; index++) {
        const subPath = subPaths[index];
        const subData = viewModel.bindingData[subPath];
        if (!subData || !subData.currentId) {
          throw Error(`è·åå­è¡¨å®æ´è·¯å¾åºéï¼æ¾ä¸å°${subData}å¯¹åºçå­è¡¨ï¼æå¯¹åºå­è¡¨æ²¡æå½åè¡ã`);
        }
        path += `/${subPath}/${subData.currentId}`;
      }
    }
    path += '/' + subPaths[subPaths.length - 1];

    return path;
  }
  private resetForm(action: string) {
    const validationService = this.frameContext.injector.get<ValidationService>(ValidationService, null);
    return this.frameContext.repository.cancelChanges().pipe(
      switchMap(() => this.commandService.execute(action).pipe(switchMap(() => {
        return validationService && validationService.resetValidation() || of(null);
      }))));
  }
  private parseParams(options: any): { action: string, id: string, sync: boolean } | null {
    if (options && Object.prototype.toString.call(options) === DataType.map) {
      let params = options.get(WEB_FORM_ROUTE_PARAMS_KEY);
      if (params && typeof params === 'string') {
        params = decodeURIComponent(params);
        if (params.startsWith('{') && params.endsWith('}')) {
          params = JSON.parse(params);
        }
        return {
          action: params.action,
          id: params.idToView || params.idToEdit || params.id,
          sync: params.sync || false
        };
      }
    }
    return null;
  }
  private showLoadingConfirm(message: string) {
    return this.formMessageService.confirm(message).pipe(
      switchMap((result: boolean) => {
        if (result === true) {
          return of(true);
        } else {
          return EMPTY;
        }
      })
    );
  }
}
export { CardDataService };
